// extracted by mini-css-extract-plugin
export default {"preRegisteredTable":"c4AOVBeJxf0fwbbjRdwu"};